export default {
    'OPERACION_CARPETA': (state, mutation) => {
        state.carpeta = mutation.carpeta
    }
}